// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstAnalisisRepartoCorral = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_analisis_reparto_corralV2',
        name: 'analisis reparto corral -( Nuevo )-',
        component: ViewLstAnalisisRepartoCorral,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
